<template>
  <div>
    <div style="padding-bottom: 20px">
      <Form
        :model="formInvoice"
        ref="formInvoice"
        :label-width="isMobile ? 100 : 180"
        :class="{ 'mobile-form': isMobile }"
        style="padding-right: 40px"
        :rules="formRules"
      >
        <div :class="{ 'mobile-radio-group': isMobile }">
          <FormItem label="发票抬头：" prop="changeRadio">
            <RadioGroup v-model="formInvoice.changeRadio" type="button">
              <Radio label="1" border>个人</Radio>
              <Radio label="2" border>单位</Radio>
            </RadioGroup>
          </FormItem>
        </div>
        <PersonalForm
          v-if="formInvoice.changeRadio == 1"
          :formInvoice="formInvoice"
          :isMobile="isMobile"
        ></PersonalForm>
        <CompanyForm
          v-if="formInvoice.changeRadio == 2"
          :formInvoice="formInvoice"
          :isMobile="isMobile"
        ></CompanyForm>
        <FormItem label="收票手机：" prop="phone">
          <Input v-model.trim="formInvoice.phone" @on-change="handlePhoneChange"></Input>
        </FormItem>
        <FormItem label="收票邮箱：" prop="email">
          <Input v-model.trim="formInvoice.email" @on-change="handleEmailChange"></Input>
        </FormItem>
        <FormItem label="" class="notice-section">
          <Row :class="{ 'mobile-notice': isMobile }">
            <Col :span="isMobile ? 24 : 1">
              <span :class="{ 'mobile-notice-title': isMobile }">注：</span>
            </Col>
            <Col :span="isMobile ? 24 : 23" style="text-align: left">
              <p :class="{ 'mobile-notice-item': isMobile }">
                <span style="color: red">
                  1.老年大学会为每一位缴费就读学员开具发票，抬头默认为学员姓名；</span
                >
              </p>
              <p :class="{ 'mobile-notice-item': isMobile }">
                <span style="color: red">
                  2.如有报销需要的学员，请根据各自单位的报销要求认真填写发票抬头信息，每次报名时仔细核对、确认；</span
                >
              </p>
              <p :class="{ 'mobile-notice-item': isMobile }">
                <span style="color: red">
                  3.一般情况下，开具单位抬头的发票只需单位名称、纳税人识别号（税号）即可报销，个别单位如需在发票上显示注册地址、注册电话、开户银行、银行账户等信息，请自行在相应栏目填写;</span
                >
              </p>
              <p :class="{ 'mobile-notice-item': isMobile }">
                <span style="color: red">
                  4.根据《同济大学离退休教职工就读老年大学学费补贴办法》，同济大学离退休教职工学费发票应为个人抬头；</span
                >
              </p>
              <p :class="{ 'mobile-notice-item': isMobile }">
                <span style="color: red">
                  5.自缴费完成至发票开具完成需一段时间，一般春季4月下旬、秋季10月下旬，含有发票号码、发票链接等信息并署名【同济大学财务处】的短信会发送至学员留存在报名系统的手机号码，点击短信中的发票链接即可打开并下载发票，请注意查收。</span
                >
              </p>
            </Col>
          </Row>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import PersonalForm from "./PersonalForm.vue";
import CompanyForm from "./CompanyForm.vue";
export default {
  props: {
    invoiceData: Object, // Declare the studentId prop
  },

  components: {
    PersonalForm,
    CompanyForm,
  },
  data() {
    // 税号验证函数
    const validateTaxNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('纳税人识别号不能为空'));
      }
      
      // 统一社会信用代码（18位）正则
      const creditCodeReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      // 旧税号（15位）正则
      const oldTaxNoReg = /^\d{15}$/;
      
      if (!creditCodeReg.test(value) && !oldTaxNoReg.test(value)) {
        return callback(new Error('请输入正确的纳税人识别号'));
      }
      callback();
    };

    return {
      isMobile: false,
      formInvoice: {
        name: "",
        changeRadio: "1",
        companyName: "",
        dutyNo: "",
        remarks: "",
        orderId: "",
        PealRemarks: "",
        id: "",
        companyId: "",
        phone: "",
        email: "",
      },
      formRules: {
        phone: [
          { required: true, message: "收票手机不能为空", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" }
        ],
        email: [
          { type: 'email', message: "请输入正确的邮箱地址", trigger: "blur" }
        ],
        companyName: [
          {
            required: true,
            message: "单位名称不能为空",
            trigger: "blur",
          },
        ],
        dutyNo: [
          {
            required: true,
            message: "纳税人识别号不能为空",
            trigger: "blur"
          },
          {
            validator: validateTaxNo,
            trigger: ['blur', 'change']
          }
        ],
      },
    };
  },
  created() {
    // 检测是否为移动端
    this.isMobile = window.innerWidth <= 768;
    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 768;
    });
    
    console.log("enter create", this.invoiceData);

    //如果已经给组件预制值了 那么不走老逻辑
    if (this.invoiceData) {
      this.formInvoice.changeRadio = this.invoiceData.invoiceType;

      //先不考虑备注的事情
      //this.formInvoice.remarks = this.invoiceData.remark;
      if (this.formInvoice.changeRadio == "1") {
        this.formInvoice.name = this.invoiceData.invoiceName;
      } else {
        this.formInvoice.name = this.invoiceData.name;
        this.formInvoice.companyName = this.invoiceData.invoiceName;
      }

      this.formInvoice.dutyNo = this.invoiceData.dutyNo;
      this.formInvoice.buyerAddress = this.invoiceData.buyerAddress;
      this.formInvoice.buyerPhone = this.invoiceData.buyerPhone;
      this.formInvoice.buyerBankName = this.invoiceData.buyerBankName;
      this.formInvoice.buyerBankAccount = this.invoiceData.buyerBankAccount;
      this.formInvoice.phone = this.invoiceData.phone;
      this.formInvoice.email = this.invoiceData.email;
      this.formInvoice.batchOrderNo = this.invoiceData.id;
    } else {
      this.formInvoice.name = sessionStorage.getItem("userNameSchool");
      //this.$refs.formInvoice.resetFields();
      this.getInvoice();
    }
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 768;
    });
  },
  methods: {
    getInvoice() {
      let _this = this;
      if (sessionStorage.getItem("studentId") != null) {
        // _this.$http
        //   .get(
        //     "retire-school-manage/studentInvoice/getStudentInvoiceByStudenId",
        //     {
        //       params: {
        //         studentId: sessionStorage.getItem("studentId"),
        //       },
        //     }
        //   )
        //   .then((res) => {
        //     if (res.data.status === 2000) {
        //       res.data.data.forEach((item) => {
        //         if (item.invoiceType == "1") {
        //           _this.formInvoice.name = item.invoiceName;
        //           _this.formInvoice.id = item.id;
        //           _this.formInvoice.studentId = item.studentId;
        //           _this.formInvoice.PealRemarks = item.remarks;
        //         } else if (item.invoiceType == "2") {
        //           _this.formInvoice.companyName = item.invoiceName;
        //           _this.formInvoice.companyId = item.id;
        //           _this.formInvoice.studentId = item.studentId;
        //           _this.formInvoice.remarks = item.remarks;
        //           _this.formInvoice.dutyNo = item.dutyNo;
        //           _this.formInvoice.buyerAddress = item.buyerAddress;
        //           _this.formInvoice.buyerPhone = item.buyerPhone;
        //           _this.formInvoice.buyerBankName = item.buyerBankName;
        //           _this.formInvoice.buyerBankAccount = item.buyerBankAccount;
        //         }
        //       });
        //     }
        //   });

        _this.$http
          .get(
            "retire-school-manage/appPay/selectLatestPaidOrderPayByStudentId",
            {
              params: {
                studentId: sessionStorage.getItem("studentId"),
              },
            }
          )
          .then((res) => {
            if (res.data.status === 2000) {
              let data = res.data.data;
              if (data) {
                _this.formInvoice.phone = data.phone;
                _this.formInvoice.email = data.email;
                
                _this.formInvoice.changeRadio = data.invoiceType;
                
                if (data.invoiceType === "1") {
                } else if (data.invoiceType === "2") {
                  _this.formInvoice.companyName = data.invoiceName;
                  _this.formInvoice.dutyNo = data.dutyNo;
                  _this.formInvoice.buyerAddress = data.buyerAddress;
                  _this.formInvoice.buyerPhone = data.buyerPhone;
                  _this.formInvoice.buyerBankName = data.buyerBankName;
                  _this.formInvoice.buyerBankAccount = data.buyerBankAccount;
                }
              }
            }
          });
      }
    },
    getInvoiceParam() {
      let _this = this;
      let params = {};
      if (_this.formInvoice.changeRadio == "1") {
        params = {
          invoiceName: _this.formInvoice.name,
          invoiceType: _this.formInvoice.changeRadio,
          id: _this.formInvoice.id,
          remarks: _this.formInvoice.PealRemarks,
          studentId: _this.formInvoice.studentId,
        };
      } else if (_this.formInvoice.changeRadio == "2") {
        params = {
          invoiceName: _this.formInvoice.companyName,
          invoiceType: _this.formInvoice.changeRadio,
          dutyNo: _this.formInvoice.dutyNo,
          buyerAddress: _this.formInvoice.buyerAddress,
          buyerPhone: _this.formInvoice.buyerPhone,
          buyerBankName: _this.formInvoice.buyerBankName,
          buyerBankAccount: _this.formInvoice.buyerBankAccount,
          remarks: _this.formInvoice.remarks,
          studentId: _this.formInvoice.studentId,
          id: _this.formInvoice.companyId,
        };
      }
      return params;
    },
    getReceiveConfig() {
      return {
        phone: this.formInvoice.phone,
        email: this.formInvoice.email || 'tjlndx@tongji.edu.cn'
      };
    },
    handlePhoneChange(event) {
      // 移除所有空格（包括中间的空格）
      this.formInvoice.phone = event.target.value.replace(/\s+/g, '');
    },
    handleEmailChange(event) {
      // 移除所有空格（包括中间的空格）
      this.formInvoice.email = event.target.value.replace(/\s+/g, '');
    },
  },
};
</script>
<style  scoped>
.btn /deep/ {
  display: flex;
  justify-content: flex-end;
}

/* 移动端样式 */
.mobile-form {
  padding-right: 0 !important;
}

.mobile-form /deep/ .ivu-form-item {
  margin-bottom: 16px;
}

.mobile-form /deep/ .ivu-form-item-label {
  padding-right: 8px;
  font-size: 14px;
}

.mobile-form /deep/ .ivu-form-item-content {
  margin-left: 0 !important;
}

.mobile-form /deep/ .ivu-input {
  height: 36px;
}

.mobile-radio-group {
  margin-bottom: 16px;
}

.mobile-radio-group /deep/ .ivu-radio-group {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
}

.mobile-radio-group /deep/ .ivu-radio-wrapper {
  margin-right: 0;
  flex: 1;
  text-align: center;
}

.mobile-notice {
  margin-top: 16px;
}

.mobile-notice-title {
  display: block;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
}

.mobile-notice-item {
  font-size: 13px !important;
  line-height: 1.5;
  margin-bottom: 8px;
  padding-left: 8px;
}

/* 移动端模态框样式 */
@media screen and (max-width: 768px) {
  .ivu-modal {
    width: 100% !important;
    margin: 0;
    top: 0;
  }

  .ivu-modal-content {
    border-radius: 0;
  }

  .ivu-modal-body {
    padding: 16px;
    max-height: calc(100vh - 108px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ivu-form {
    padding-right: 0 !important;
  }

  .ivu-form-item {
    margin-bottom: 16px;
  }

  .ivu-input {
    height: 36px;
  }

  .ivu-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .ivu-radio-wrapper {
    margin-right: 0;
    flex: 1;
    min-width: 120px;
  }
}
</style>
